<div class="committed-exchanges-container container-fluid">
  <ng-container>
    <div class="row">
      <div class="col-md-2">
        <div>
          <span class="status-icon">
            <i class="fa fa-shield status-icon--md icon"></i>
          </span>
        </div>
      </div>
      <div class="col-md-10">
        <div><h1>Application Error</h1></div>
        <div class="error-msg">
          {{ displayErrorCode ? displayErrorCode : '' }} :
          {{ displayResolution ? displayResolution : '' }}
        </div>
        <div class="error-msg-resolution-text">{{ displayMessage ? displayMessage : '' }}</div>

        <div class="back-and-edit" (click)="goToHome()">
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Back to home page
        </div>
      </div>
    </div>
  </ng-container>

  <!--<ng-container *ngIf="this.displayStatusCode == 500">-->
  <!--<div class="row">-->
  <!--<div class="col-md-2 ">-->
  <!--<div ><div > <span class="status-icon">-->
  <!--<i class="fa fa-shield status-icon&#45;&#45;md  icon" ></i>-->
  <!--</span></div></div>-->
  <!--</div>-->
  <!--<div class="col-md-10 ">-->
  <!--<div ><h1>System Error</h1></div>-->
  <!--<div class="error-msg">{{displayErrorCode?displayErrorCode : ""}} :  {{displayMessage?displayMessage : ""}}</div>-->
  <!--<div class="error-msg-resolution-text">{{displayResolution?displayResolution : ""}}</div>-->
  <!--<div class="back-and-edit" (click)="goToHome()">-->
  <!--<i class="fa fa-arrow-circle-o-left go-back-icon"></i>Back to home page-->
  <!--</div>-->
  <!--</div>-->
  <!--</div>-->
  <!--</ng-container>-->
</div>
